export class EmbeddedManager {
    constructor(embedded, isSmartLaunch) {
        this.embedded = embedded;
        this.isSmartLaunch = isSmartLaunch;
    }
}
